import { observer } from 'mobx-react-lite';
import NavigationButton, { NavigationButtonProps } from '../button-navigation';
import style from './style.module.scss';
import { useStore } from '../../lib/hooks/useStore';
import CurrencyValue from '../currency-value';
import { icons } from '../../lib/helpers/icons';
import { AppIconType } from '../../lib/typegen/app-icon-type';

export interface NavigationBarProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	previousPageId?: string | null;
	nextPageId?: string | null;
	previousButtonProps?: NavigationButtonProps | null;
	nextButtonProps?: NavigationButtonProps | null;
	handleNavigation: (pageId: string) => void;
}

const Layout = observer(function NavigationBar({
	previousPageId,
	previousButtonProps,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	nextButtonProps,
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	nextPageId,
	className,
	handleNavigation,
	...props
}: NavigationBarProps) {
	const {
		uiStore: { isBackEnabled, showCart, handleCustomBackAction, isCustomBackActionSet },
		accountStore: { cartTotalAmount },
	} = useStore();

	const Icon = icons[AppIconType.Cart];

	return (
		<nav {...props} className={[style.nav, className].join(' ')}>
			<NavigationButton
				{...previousButtonProps}
				className={[style.nav__prev, !isBackEnabled || !previousButtonProps ? style['nav--hidden'] : ''].join(' ')}
				onClick={() => {
					if (previousPageId && !isCustomBackActionSet()) handleNavigation(previousPageId);
					else handleCustomBackAction?.();
				}}
			/>
			{/* {nextPageId && nextButtonProps && (
				<NavigationButton {...nextButtonProps} className={style.nav__next} onClick={() => handleNavigation(nextPageId)} />
			)} */}
			<div className={[style.nav__cart, style.cart, !showCart ? style['cart--hidden'] : ''].join(' ')}>
				<Icon className={style.cart__icon} />
				<CurrencyValue value={cartTotalAmount} className={style.cart__value} />
			</div>
		</nav>
	);
});

export default Layout;
